import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"
import { Row } from "reactstrap"

class CIIChart extends Component<any> {
    Chart = () => {
        const data = this.props.graphData;
        const Dec31st = this.props.graphData.filter((item: any) => item.reporting_date?.toString()?.substring(5) === '12-31')[0];
        const colors = ['#5470C6', '#91CC75', '#EE6666'];
        return {
            color: colors,
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    },
                    formatter: function (params: any) {
                    }
                },
                showContent: false
            },
            toolbox: {
                feature: {
                    saveAsImage: { show: true },
                }
            },
            legend: {
                data: ['CII Ratio', 'Steaming Time']
            },
            xAxis: [
                {
                    type: 'category',
                    axisTick: {
                        alignWithLabel: true
                    },
                    data: this.props.graphData.map((dt: any) => { return dt.reporting_date }),
                    axisLabel: {
                        formatter: function (values: any) {
                            var date = new Date(values);
                            var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                            return monthNames[date.getMonth()];
                        },
                        interval: Math.ceil(data.length / 12),
                    },
                }
            ],
            yAxis: [
                // {
                //     type: 'value',
                //     name: 'Steaming time',
                //     position: 'right',
                //     alignTicks: true,
                //     axisLine: {
                //         show: true,
                //         lineStyle: {
                //             color: colors[0]
                //         }
                //     },
                //     axisLabel: {
                //         formatter: '{value} min'
                //     }
                // },
                {
                    type: 'value',
                    name: 'CII ratio',
                    position: 'left',
                    alignTicks: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: colors[2]
                        }
                    },
                    axisLabel: {
                        formatter: '{value}'
                    },
                }
            ],
            series: [
                {
                    name: "A",
                    type: 'line',
                    stack: 'Total',
                    areaStyle: {},
                    // yAxisIndex: 1,
                    symbol: 'none',
                    color: "#058742",
                    data: this.props.graphData.map((dt: any) => { return dt.a }),
                    tooltip: false,
                    markLine: Dec31st ? {
                        data: [
                            {
                                xAxis: Dec31st?.reporting_date,
                                label: {
                                    formatter: '31st Dec',
                                    position: 'middle',
                                    color: 'red'
                                },
                                lineStyle: {
                                    type: 'dotted',
                                    color: 'red'
                                },
                                symbol: 'none'
                            }
                        ]
                    } :
                        null
                },
                {
                    name: "B",
                    type: 'line',
                    stack: 'Total',
                    areaStyle: {},
                    // yAxisIndex: 1,
                    symbol: 'none',
                    color: "#8bc63e",
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData.map((dt: any) => { return (dt.b - dt.a) }),
                    markLine: Dec31st ? {
                        data: [
                            {
                                xAxis: Dec31st?.reporting_date,
                                label: {
                                    formatter: '31st Dec',
                                    position: 'middle',
                                    color: 'red'
                                },
                                lineStyle: {
                                    type: 'dotted',
                                    color: 'red'
                                },
                                symbol: 'none'
                            }
                        ]
                    } :
                        null
                },
                {
                    name: "C",
                    type: 'line',
                    stack: 'Total',
                    areaStyle: {},
                    // yAxisIndex: 1,
                    symbol: 'none',
                    color: "#f7ee21",
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData.map((dt: any) => { return (dt.c - dt.b) }),
                    markLine: Dec31st ? {
                        data: [
                            {
                                xAxis: Dec31st?.reporting_date,
                                label: {
                                    formatter: '31st Dec',
                                    position: 'middle',
                                    color: 'red'
                                },
                                lineStyle: {
                                    type: 'dotted',
                                    color: 'red'
                                },
                                symbol: 'none'
                            }
                        ]
                    } :
                        null
                },
                {
                    name: "D",
                    type: 'line',
                    stack: 'Total',
                    areaStyle: {},
                    // yAxisIndex: 1,
                    symbol: 'none',
                    color: "#fbb03f",
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData.map((dt: any) => { return dt.d - dt.c }),
                    markLine: Dec31st ? {
                        data: [
                            {
                                xAxis: Dec31st?.reporting_date,
                                label: {
                                    formatter: '31st Dec',
                                    position: 'middle',
                                    color: 'red'
                                },
                                lineStyle: {
                                    type: 'dotted',
                                    color: 'red'
                                },
                                symbol: 'none'
                            }
                        ]
                    } :
                        null
                },
                {
                    name: "E",
                    type: 'line',
                    stack: 'Total',
                    areaStyle: {},
                    // yAxisIndex: 1,
                    symbol: 'none',
                    color: "#f3786e",
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.props.graphData.map((dt: any) => { return this.props.maxRating }),
                    markLine: Dec31st ? {
                        data: [
                            {
                                xAxis: Dec31st?.reporting_date,
                                label: {
                                    formatter: '31st Dec',
                                    position: 'middle',
                                    color: 'red'
                                },
                                lineStyle: {
                                    type: 'dotted',
                                    color: 'red'
                                },
                                symbol: 'none'
                            }
                        ]
                    } :
                        null
                },
                {
                    name: "CII Ratio",
                    type: 'line',
                    // yAxisIndex: 1,
                    symbol: 'none',
                    color: '#000000',
                    data: this.props.graphData.map((dt: any) => { return dt.cii_rating }),
                },
                // {
                //     name: "Steaming Time",
                //     type: 'bar',
                //     color: colors[0],
                //     data: this.props.graphData.map((dt: any) => { return dt.steaming_time }),
                // },
            ]
        }
    }
    render() {
        return (
            <>
                <Row>
                    <ReactEcharts style={{ height: "350px" }} option={this.Chart()} />
                </Row>
            </>
        )
    }
}

export default CIIChart;